import { useTenantAdmin } from '~/hooks/useTenantAdmin';

/**
 * Who sees the Archived view and the archive / unarchive controls: super admins
 * and org (tenant) admins. Members never see archive UI — their lists simply
 * omit archived rows (the server default). One policy point so the audience can
 * change without touching three list pages and three detail headers.
 */
export function useCanManageArchive(): boolean {
  return useTenantAdmin();
}
